import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AdaptEditorViewModule } from "@common/ux/html-editor/editor-view.module";
import { AdaptLoadingSpinnerModule } from "@common/ux/loading-spinner/loading-spinner.module";
import { DxChartModule, DxDataGridModule, DxPolarChartModule } from "devextreme-angular";
import { CulturalIndexHistoryComponent } from "./ci-history/ci-history.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AdaptLoadingSpinnerModule,
        DxChartModule,
        DxPolarChartModule,
        DxDataGridModule,
        AdaptEditorViewModule,
    ],
    declarations: [
        CulturalIndexHistoryComponent,
    ],
    exports: [
        CulturalIndexHistoryComponent,
    ],
    providers: [],
})
export class AdaptCulturalIndexSharedModule {
}
